<script>
  import "@spectrum-css/tags/dist/index-vars.css"
</script>

<div class="spectrum-Tags" role="list" aria-label="list">
  <slot />
</div>
